import { observe } from 'mobx';
import type { FaceDetectionEventAttributeItemDto } from '../Types/index.ts';

/**
 * Waits for the classification attribute matching `detectId` to appear in the
 * observable `events` array. Resolves with its `Value`, or `null` on timeout.
 */
export function awaitClassification(
    events: FaceDetectionEventAttributeItemDto[],
    detectId: string,
    timeoutMs: number,
): Promise<string | null> {
    const immediate = events.find((a) => a.DetectId === detectId);
    if (immediate) return Promise.resolve(immediate.Value);

    return new Promise<string | null>((resolve) => {
        let settled = false;
        const settle = (value: string | null) => {
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            disposer();
            resolve(value);
        };
        const timer = setTimeout(() => settle(null), timeoutMs);
        const disposer = observe(events, () => {
            const found = events.find((a) => a.DetectId === detectId);
            if (found) settle(found.Value);
        });
    });
}
